// extracted by mini-css-extract-plugin
export var chip = "_44-0";
export var filterDropdown = "_44-5";
export var filterItem = "_44-6";
export var icon = "_44-1";
export var removeButton = "_44-3";
export var removeIcon = "_44-4";
export var separator = "_44-2";